import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["frame"]

    connect() {
        this.handleHidden  = this.handleHidden.bind(this)
        this.handleSubmit  = this.handleSubmit.bind(this)

        this.element.addEventListener("hidden.bs.modal", this.handleHidden)
        document.addEventListener("turbo:submit-end", this.handleSubmit)

        this.observer = new MutationObserver(() => {
            if (this.hasFrameTarget && this.frameTarget.innerHTML.trim() === "") {
                this.close()
            }
        })

        if (this.hasFrameTarget) {
            this.observer.observe(this.frameTarget, { childList: true, subtree: true })
        }
    }

    disconnect() {
        this.element.removeEventListener("hidden.bs.modal", this.handleHidden)
        document.removeEventListener("turbo:submit-end", this.handleSubmit)
        this.observer?.disconnect()
        window.bootstrap?.Modal.getInstance(this.element)?.dispose()
    }

    open(event) {
        const url = event.relatedTarget?.dataset?.url
        if (url && this.hasFrameTarget) {
            this.frameTarget.src = url
        }
    }

    handleSubmit(event) {
        if (!event.detail.success) return

        const modal = window.bootstrap?.Modal.getInstance(this.element)
        if (!modal) return

        this.shouldResetFrame = true
        modal.hide()
    }

    closeOnSuccess(event) {
        if (!event.detail.success) return

        const modal = window.bootstrap?.Modal.getInstance(this.element)
        if (!modal) return

        this.shouldResetFrame = true
        modal.hide()
    }

    close() {
        const modal = window.bootstrap?.Modal.getInstance(this.element)
        if (!modal) return

        this.shouldResetFrame = true
        modal.hide()
    }

    handleHidden() {
        if (!this.shouldResetFrame) return
        this.shouldResetFrame = false

        if (this.hasFrameTarget) {
            this.frameTarget.removeAttribute("src")
            this.frameTarget.innerHTML = ""
        }
    }
}